import { getSortOrderFromHeaderClick } from "helpers/util-common";
import { DateTime } from 'luxon';
import { encrypt, paginateData } from "../../../../../helpers/util-common";
import { MemberStatusEnum } from "../../../../ballot-admin/ballot-admin.model";
import { BallotVoteIdThresVal, orderTypeAsc, PaginateOrder, VoteStatusEnum } from "../../members.model";
let self = null;
let memberId_param = null;
let memberAccountNumber_param = null;
let header_info = null;
export const setInstance = (instance) => {
  self = instance;
};

export const sortByHandler = (event, sortKey) => {
  const orderType = getSortOrderFromHeaderClick(event);
  const sortOrder = orderType === orderTypeAsc ? "Asc" : "Desc";

  const sortedData = [...self.state.VoteHistoryList].sort((a, b) => {
    const valA = a[sortKey];
    const valB = b[sortKey];

    if (sortKey === "SubmissionDate") {
      const dateA = new Date(valA);
      const dateB = new Date(valB);
      return sortOrder === "Asc" ? dateA - dateB : dateB - dateA;
    }

    if (typeof valA === "number" && typeof valB === "number") {
      return sortOrder === "Asc" ? valA - valB : valB - valA;
    }

    if (typeof valA === "string" && typeof valB === "string") {
      return sortOrder === "Asc"
        ? valA.localeCompare(valB)
        : valB.localeCompare(valA);
    }

    return 0;
  });

  self.setState({
    VoteHistoryList: sortedData,
  });
};

export const resetBallotHeaderInfo = (item) => {
  header_info = item;
  const arrayData = item.findIndex((element) => element.orderByIcon === 1);
  if (arrayData > 0) {
    item[arrayData]["orderByIcon"] = PaginateOrder['sortNEnabled'];
    item[0]["orderByIcon"] = PaginateOrder['sortEnabled'];
  }
};

export const onPageChangeHandler = (event, data) => {
  const { activePage } = data;
  const { pageSize, voteStatus, searchKey, AutoSuggestUserData } = self.state;

  let filteredData = AutoSuggestUserData;
  if (voteStatus === VoteStatusEnum['NSubmitted']) {
    filteredData = filteredData.filter(
      (p) => (p.BallotVoteId === BallotVoteIdThresVal) & (p.VoteStatus ===VoteStatusEnum['SubmittedNSaved'])
    );
  } else if (voteStatus === VoteStatusEnum['Submitted']) {
    filteredData = filteredData.filter(
      (p) => (p.BallotVoteId > BallotVoteIdThresVal) & (p.VoteStatus === VoteStatusEnum['Submitted'])
    );
  } else if (voteStatus === VoteStatusEnum['SubmittedNSaved']) {
    filteredData = filteredData.filter(
      (p) => (p.BallotVoteId > BallotVoteIdThresVal) & (p.VoteStatus === VoteStatusEnum['SubmittedNSaved'])
    );
  }

  if (searchKey && searchKey !== "default") {
    filteredData = filteredData.filter((p) =>
      String(p.BallotNumber.toLowerCase()).includes(searchKey.toLowerCase())
    );
  }

  const pagedData = paginateData(filteredData, activePage, pageSize);

  self.setState({
    VoteHistoryList: pagedData,
    pageNumber: activePage,
    TotalRecords: filteredData.length,
  });
};

export const onChangeNumberOfItemsPerPage = (e, value) => {
  const pageSize = parseInt(e.target.innerText);
  const { AutoSuggestUserData, voteStatus, searchKey } = self.state;

  let filteredData = AutoSuggestUserData;

  if (voteStatus === VoteStatusEnum['NSubmitted']) {
    filteredData = filteredData.filter(
      (p) => (p.BallotVoteId === BallotVoteIdThresVal) & (p.VoteStatus === VoteStatusEnum['SubmittedNSaved'])
    );
  } else if (voteStatus === VoteStatusEnum['Submitted']) {
    filteredData = filteredData.filter(
      (p) => (p.BallotVoteId > BallotVoteIdThresVal) & (p.VoteStatus === VoteStatusEnum['Submitted'])
    );
  } else if (voteStatus === VoteStatusEnum['SubmittedNSaved']) {
    filteredData = filteredData.filter(
      (p) => (p.BallotVoteId > BallotVoteIdThresVal) & (p.VoteStatus === VoteStatusEnum['SubmittedNSaved'])
    );
  }

  if (searchKey && searchKey !== "default") {
    filteredData = filteredData.filter((p) =>
      String(p.BallotNumber.toLowerCase()).includes(searchKey.toLowerCase())
    );
  }

  const pagedData = paginateData(filteredData, 1, pageSize);

  self.setState({
    VoteHistoryList: pagedData,
    pageNumber: 1,
    pageSize,
    TotalRecords: filteredData.length,
  });
};

export const getInitalData = () => {

  const { getMemberAccountDetails, match, initialValues } = self.props;
  const { MemberId, AccountNumber } = initialValues;
  memberId_param = MemberId;
  memberAccountNumber_param = AccountNumber;
  self.setState(
    {
      pageNumber: 1,
      pageSize: 25,
      VoteHistoryList: [],
      sortBy: "default",
      sortOrder: "default",
      index: 1,
      TotalRecords: "",
      currentDate: DateTime.now().toFormat('MM-dd-yyyy'),
      beforeOneYearDate: DateTime.now().isInLeapYear
      ? DateTime.now().minus({ days: 366 }).toFormat('MM-dd-yyyy')
      : DateTime.now().minus({ days: 365 }).toFormat('MM-dd-yyyy'),
      voteStatus: -1,
    },
    () => {
      header_info.map((item) => {
        item["orderByIcon"] = PaginateOrder['sortNEnabled'];
        item["orderBy"] = PaginateOrder['sortNEnabled'];
      });
      header_info[0]["orderByIcon"] = PaginateOrder['sortEnabled'];
      header_info[0]["orderBy"] = PaginateOrder['sortEnabled'];
      const dtoArguments = [
        memberAccountNumber_param,
        memberId_param,
        "default",
        self.state.beforeOneYearDate,
        self.state.currentDate,
        self.state.sortBy,
        self.state.sortOrder,
        self.state.index,
        "default",
      ];
      getMemberAccountDetails(encrypt(match.params.accountNumber), (res) => {
        if (
          res &&
          res.StatusName &&
          (res.StatusName == MemberStatusEnum.Active ||
            res.StatusName == MemberStatusEnum.Historical)
        ) {
          self.props.getBallotVoteHistory(...dtoArguments, true, (response) => {
            const sorted = response.sort(
              (a, b) => new Date(a.SubmissionDate) - new Date(b.SubmissionDate)
            );
            const pagedData = paginateData(sorted, 1, self.state.pageSize);
            self.setState({
              VoteHistoryList: pagedData,
              AutoSuggestUserData: sorted,
              TotalRecords: sorted.length,
            });
          });
        }
      });
    }
  );
};

export const getMemberId = () => memberId_param;
export const getMemberAccountNumber = () => memberAccountNumber_param;

export const onChangeDropdownBallotStatus = (e, value) => {
  const { AutoSuggestUserData, pageSize, searchKey } = self.state;

  let filteredData = AutoSuggestUserData;
  if (value === VoteStatusEnum['NSubmitted']) {
    filteredData = filteredData.filter(
      (p) => (p.BallotVoteId === BallotVoteIdThresVal) & (p.VoteStatus === VoteStatusEnum['SubmittedNSaved'])
    );
  } else if (value === VoteStatusEnum['Submitted']) {
    filteredData = filteredData.filter(
      (p) => (p.BallotVoteId > BallotVoteIdThresVal) & (p.VoteStatus === VoteStatusEnum['Submitted'])
    );
  } else if (value === VoteStatusEnum['SubmittedNSaved']) {
    filteredData = filteredData.filter(
      (p) => (p.BallotVoteId > BallotVoteIdThresVal) & (p.VoteStatus === VoteStatusEnum['SubmittedNSaved'])
    );
  }

  if (searchKey && searchKey !== "default") {
    filteredData = filteredData.filter((p) =>
      String(p.BallotNumber.toLowerCase()).includes(searchKey.toLowerCase())
    );
  }

  const pagedData = paginateData(filteredData, 1, pageSize);

  self.setState({
    voteStatus: value,
    VoteHistoryList: pagedData,
    TotalRecords: filteredData.length,
    pageNumber: 1,
  });
};
